module.exports = __webpack_public_path__ + "static/img/project06.8b14aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project06.png
// module id = St0I
// module chunks = 1